<template>
  <ul class="ml-0 flex flex-col gap-2">
    <li
      v-for="item in filteredItems"
      :key="item.value"
      class="list-none text-EXPONDO-grey"
    >
      <label
        class="cursor-pointer leading-relaxed flex justify-between items-center"
        :class="{ 'font-bold': item.isRefined }"
      >
        <div class="flex items-center gap-1">
          <CheckBox
            :is-checked="item.isRefined"
            @change="handleChange(item)"
          />
          <span
            v-if="item.value !== minRating"
            class="flex items-center flex-wrap"
          >
            <ReviewsStars :rating="item.value" />
            <span
              v-if="item.value !== maxRating"
              class="text-sm leading-4 whitespace-nowrap"
            >
              {{ $t('and Up') }}
            </span>
          </span>
          <span
            v-else
            class="text-sm"
          >
            {{ $t('All reviewed products') }}
          </span>
        </div>
        <FacetCount :item="item" />
      </label>
    </li>
  </ul>
</template>

<script lang="ts">

import type { RefinementListItem } from 'vue-instantsearch/vue3/es';

import { RATING_TO_IGNORE } from '~~/constants/typesense';
import { MAX_POINTS_FOR_RATINGS, MIN_POINTS_FOR_RATINGS } from '~~/constants/reviews';
import { EVENT_SOURCE, FILTERS_INTERACTIONS } from '~~/constants/googleTagManager';

export default defineComponent({
  name: 'RatingMenuInner',

  props: {
    items: {
      type: Array as PropType<RefinementListItem[]>,
      required: true,
    },
    refine: {
      type: Function as PropType<(value: string) => void>,
      required: true,
    },
  },
  setup(props) {

    const i18n = useI18n();
    const { callClickFilterEvent } = useClickFiltersEvent();
    const localisedName = computed(() => i18n.t('Ratings'));

    const handleChange = (item: RefinementListItem) => {

      const filterInteraction =
        item.isRefined ? FILTERS_INTERACTIONS.FILTER_UNSELECT : FILTERS_INTERACTIONS.FILTER_SELECT;

      callClickFilterEvent({
        filterInteraction,
        filterSection: EVENT_SOURCE.RATINGS,
        filterName: localisedName.value,
        filterValue: item.value,
      });
      props.refine(item.value);

    };

    const filteredItems = computed(() => props.items.filter(
      item => item.value !== RATING_TO_IGNORE && item.count !== 0,
    ));

    const minRating = MIN_POINTS_FOR_RATINGS.toString();
    const maxRating = MAX_POINTS_FOR_RATINGS.toString();

    return {
      filteredItems,
      minRating,
      maxRating,
      handleChange,
    };

  },
});

</script>
